<template>
  <div class="app-main goods-list">
    <div class="top-bar">
      <el-input
        placeholder="输入商品名称"
        v-model="value"
        @change="search()"
        clearable
        style="width: 300px; margin-right: 20px"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>
    <!-- 商品列表 -->
    <el-card shadow="hover">
      <el-table ref="multipleTable" :data="tableData" height="600">
        <el-table-column
          prop="shops_info.title"
          label="所属商家"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="商品图片" align="center">
          <template slot-scope="scope">
            <m-img v-if="scope.row.image_url" :src="scope.row.image_url" />
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="商品名称"
          align="center"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="name" label="商品类型" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.goods_type == 2">食品类型</span>
            <span v-else-if="scope.row.goods_type == 3">服务类型</span>
            <span v-else>普通商品</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_at"
          align="center"
          label="上架时间"
          min-width="140"
        ></el-table-column>
        <el-table-column prop="totalMoney" align="center" label="商品操作">
          <template slot-scope="scope">
            <div class="table-btns">
              <el-button
                @click="getDetail(scope.row.id)"
                type="success"
                plain
                size="mini"
                >查看详情</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="reloadData"
        :current-page.sync="page"
        layout="prev, pager, next, jumper"
        style="padding: 15px"
        :total="total"
        :page-size="20"
      ></el-pagination>
    </el-card>

    <el-dialog
      title="商品详情"
      center
      :visible.sync="dialog"
      width="1245px"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <el-card class="m-bottom-4">
        <el-row class="m-bottom-2">
          <el-col :span="2" class="label-left">中文名称</el-col>
          <el-col :span="22">
            <el-input
              v-model="detail.name"
              readonly
              style="width: 600px"
            ></el-input>
          </el-col>
        </el-row>
        <el-row class="m-bottom-2">
          <el-col :span="2" class="label-left">英文名称</el-col>
          <el-col :span="22">
            <el-input
              v-model="detail.name_en"
              readonly
              style="width: 600px"
            ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2" class="label-left"> 关 键 词 </el-col>
          <el-col :span="22">
            <el-input
              v-model="detail.description"
              type="textarea"
              resize="none"
              readonly
              autosize
              style="width: 600px"
            ></el-input>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="m-bottom-4">
        <el-row>
          <el-col :span="2" class="label-image">商品视频</el-col>
          <el-col :span="22">
            <Video
                :video.sync="video"
                :width="120"
                :height="120"
                file-name="goodsVideo"
              ></Video>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="m-bottom-4">
        <el-row>
          <el-col :span="2" class="label-image">轮播图</el-col>
          <el-col :span="22">
            <m-img
              v-for="(it, index) in detail.round_pic_url"
              :key="index"
              :src="it.url"
            />
          </el-col>
        </el-row>
      </el-card>

      <el-card class="m-bottom-4">
        <el-row class="m-bottom-4">
          <el-col :span="2" class="label-image">中文详情</el-col>
          <el-col :span="22">
            <m-img
              v-for="(it, index) in detail.goods_details"
              :key="index"
              :src="it.url"
              :width="160"
              placement="top"
            />
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2" class="label-image">英文详情</el-col>
          <el-col :span="22">
            <m-img
              v-for="(it, index) in detail.goods_details_en"
              :key="index"
              :src="it.url"
              :width="160"
              placement="bottom"
            />
          </el-col>
        </el-row>
      </el-card>

      <el-card class="m-bottom-4" style="overflow-y: auto">
        <el-row class="m-bottom-4" v-if="detail.sku_list">
          <div class="sku-items-head">
            <div class="m-width-140"><span>规格 | SKU</span></div>
            <div class="m-width-100"><span>销售价(C$)</span></div>
            <div class="m-width-100"><span>预售价(C$)</span></div>
            <div class="m-width-100"><span>代理价(C$)</span></div>
            <div class="m-width-120"><span>重量(单位kg)</span></div>
            <div class="m-width-100"><span>长(单位cm)</span></div>
            <div class="m-width-100"><span>宽(单位cm)</span></div>
            <div class="m-width-100"><span>高(单位cm)</span></div>
            <div class="m-width-160"><span>条形码</span></div>
            <div class="m-width-100"><span>变量图片</span></div>
          </div>
          <div
            class="sku-items-body"
            v-for="(it, index) in detail.sku_list"
            :key="index"
          >
            <div class="m-width-140">
              <el-input
                v-model="it.attr_symbol_string"
                size="small"
                readonly
                style="margin-bottom: 5px"
              ></el-input>
              <el-input
                v-model="it.attr_symbol_string_en"
                size="small"
                readonly
              ></el-input>
            </div>
            <div class="m-width-100">
              <el-input v-model="it.price" readonly size="small"></el-input>
            </div>
            <div class="m-width-100">
              <el-input v-model="it.pre_sale_price" readonly size="small"></el-input>
            </div>
            <div class="m-width-100">
              <el-input
                v-model="it.proxy_price"
                readonly
                size="small"
              ></el-input>
            </div>
            <div class="m-width-120">
              <el-input
                v-model="it.goods_weight"
                readonly
                size="small"
              ></el-input>
            </div>
            <div class="m-width-100">
              <el-input
                v-model="it.goods_length"
                readonly
                size="small"
              ></el-input>
            </div>
            <div class="m-width-100">
              <el-input
                v-model="it.goods_width"
                readonly
                size="small"
              ></el-input>
            </div>
            <div class="m-width-100">
              <el-input
                v-model="it.goods_height"
                readonly
                size="small"
              ></el-input>
            </div>
            <div class="m-width-160">
              <el-input v-model="it.barcode" size="small" readonly></el-input>
            </div>
            <div class="m-width-100" style="text-align: center">
              <m-img :src="it.sku_pic_url" placement="left" />
            </div>
          </div>
        </el-row>
        <el-row class="m-bottom-4" v-if="detail.sku_list">
          <div class="sku-items-head">
            <div class="m-width-160"><span>售后服务状态</span></div>
          </div>
          <div class="sku-items-body">
            <div class="m-width-160">
              <el-input v-model="after_sale" size="small" readonly></el-input>
            </div>
          </div>
        </el-row>
      </el-card>

      <el-card>
        <el-row type="flex" justify="space-around" style="padding: 0 300px">
          <el-button
            type="danger"
            plain
            :disabled="disabled"
            @click="reason_modal = true"
            style="width: 120px"
            >未通过审核</el-button
          >
          <el-button
            type="info"
            plain
            :disabled="disabled"
            @click="dialog = false"
            style="width: 120px"
            >关闭</el-button
          >
          <el-button
            type="success"
            plain
            :disabled="disabled"
            @click="goodsCheck(1)"
            style="width: 120px"
            >通过审核</el-button
          >
        </el-row>
      </el-card>
    </el-dialog>
    <el-dialog
      width="600px"
      title="拒绝原因"
      :visible.sync="reason_modal"
      center
      append-to-body
    >
      <el-row
        class="row-height m-bottom-4"
        type="flex"
        justify="center"
        style="line-height: 40px"
      >
        拒绝原因：
        <el-input
          placeholder="输入拒绝原因"
          v-model="reason"
          style="width: 300px"
        ></el-input>
      </el-row>
      <el-row type="flex" justify="center" style="margin-top:20px;">
        <el-button
          type="info "
          style="margin-right: 30px; width: 120px"
          @click="reason_modal = false"
          >取消</el-button
        >
        <el-button
          type="success"
          style="margin-left: 30px; width: 120px"
          @click="nogoodsCheck(6)"
          :disabled="disabled"
          >确定</el-button
        >
      </el-row>
    </el-dialog>
  </div>
</template>



<script>
/* eslint-disable */
import { goods, detail } from "@/api/merchant.js";
import { goods_status} from "@/api/goods.js";
import MImg from "./../../../components/Image";
import Video from "@/components/video.vue";

export default {
  components: { MImg, Video },
  data() {
    return {
      value: "",
      tableData: [],
      table_load: false,
      total: 0,
      page: 1,
      dialog: false,
      detail: {},
      video: { video_pic: "", video_id: "" },
      disabled: false,
      reason: "",
      reason_modal: false
    };
  },
  methods: {
    search() {
      this.page = 1;
      this.getData();
    },
    getData() {
      this.tableData = [];
      let params = {
        page: this.page,
      };
      if (this.value != "") {
        params.search = this.value;
      }
      goods(3, params).then((res) => {
        console.log();
        if (res) {
          this.tableData = res.data.data;
          this.total = res.data.total;
        } else {
          this.tableData = [];
          //this.$message.error("Error");
        }
      });
    },
    reloadData(page) {
      this.page = page;
      this.getData();
      this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
    },
    goodsCheck(flag) {
      let params = {
        status: flag,
      };
      this.disabled = true;
      goods_status(this.detail.id, params)
        .then((res) => {
          if (res) {
            this.$message({ message: res.msg, type: "success" });
            this.getData();
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.dialog = false;
          this.disabled = false;
        });
    },
    nogoodsCheck(flag) {
      let params = {
        status: flag,
      };
      if (this.reason == "") {
          this.$message({ message: '请输入拒绝原因！', type:"danger" });
          return false;
      }
      params.audit_failure = this.reason;
      this.disabled = true;
      goods_status(this.detail.id, params)
        .then((res) => {
          if (res) {
            this.reason_modal = false;
            this.$message({ message: res.msg, type: "success" });
            this.getData();
          } else {
            this.$message.error(res.msg);
            this.reason_modal = false;
          }
        })
        .finally(() => {
          this.dialog = false;
          this.disabled = false;
            this.reason_modal = false;
        });
    },

    // 显示详情

    getDetail(id) {
      this.detail = {};
      detail(id).then((res) => {
        if (res) {
          this.detail = res.data;
          this.dialog = true;
          if (res.data.video_id != 0) {
            this.video = res.data.video_url;
          } else {
            this.video = { video_pic: "", video_id: "" };
          }
          res.data.sku_list.forEach(item => {
            if(item.attr_symbol_string_en == ',') {
              item.attr_symbol_string_en = ''
            }
          });
        }
      });
    },
  },
  computed: {
    // 售后服务状态
    after_sale() {
      if (this.detail.after_sale == 1) {
        return "七天无理由退货";
      } else if (this.detail.after_sale == 2) {
        return "非质量问题不退不换";
      } else {
        return "商品售出不退不换";
      }
    },
  },
  created() {
    this.getData();
  },
  activated() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
.label-left {
  min-width: 80px;
  height: 40px;
  line-height: 40px;
}
.label-image {
  min-width: 80px;
  height: 70px;
  line-height: 70px;
}
.sku-value {
  height: 40px;
  line-height: 40px;
  margin: 20px 15px 0 0;
}
.sku-input {
  width: 150px;
  margin-right: 20px;
}
.m-width-100 {
  width: 90px;
}
.m-width-120 {
  width: 100px;
}
.m-width-140 {
  width: 130px;
}
.m-width-160 {
  width: 150px;
}
.sku-items-head {
  min-width: 1305px;
  display: flex;
  background: #f5f7fa;
  border: 1px solid #e8e8e8;
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    padding: 0 8px;
    font-size: 15px;
    color: #8c939d;
    > span {
      display: inline-block;
      width: 100%;
      height: 36px;
      background: #fff;
      text-align: center;
      line-height: 36px;
      border-radius: 3px;
    }
  }
}
.sku-items-body {
  min-width: 1305px;
  display: flex;
  border: 1px solid #e8e8e8;
  border-top: none;
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 80px;
    padding: 0 8px;
    font-size: 15px;
    color: #8c939d;
  }
  .avatar-uploader-icon {
    width: 60px;
    height: 60px;
    line-height: 60px !important;
    border: 1px solid #e0e0e0;
  }
}
.sku-tips {
  line-height: 30px;
  margin-top: 5px;
  color: red;
}
/deep/ .el-input--small .el-input__inner {
  text-align: center;
}
</style>
